import React from "react";
import {
  CheckIcon,
  PencilSquareIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { isEqual } from "lodash";
import { useColors } from "../provider/colors-provider";
import { TextField, Button } from "@mui/material";

type Props = {
  label: string;
  initialValue: number;
  value: number;
  setValue: (v: any) => void;
  editable: boolean;
  onEdit: (v: any) => void;
  onSave: () => void;
  onCancel: () => void;
};

const SimpleSecondsContainer = ({
  label,
  initialValue,
  value,
  setValue,
  editable,
  onEdit,
  onSave,
  onCancel,
}: Props) => {
  const { primary } = useColors();

  return (
    <div className="my-4 block w-full p-6 bg-gray-100 border border-gray-200 rounded-lg shadow">
      <p className="w-full flex gap-2 items-start font-normal text-gray-700 dark:text-gray-400">
        {label}: {!editable && `${value} seconds`}
        {!editable && (
          <span className="ml-2">
            <PencilSquareIcon
              className="w-5 hover:opacity-50 hover:cursor-pointer"
              onClick={() => {
                onEdit(true);
              }}
            />
          </span>
        )}
        {editable && (
          <div className="w-max flex flex-col gap-2">
            <div className="flex items-start gap-2">
              <TextField
                type="number"
                label="Seconds"
                value={value || ""}
                size="small"
                sx={{ width: 150 }}
                inputProps={{
                  min: 5,
                  step: 1,
                }}
                error={Number(value) < 5}
                helperText={Number(value) < 5 ? "Must be 5 or greater" : ""}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setValue(newValue === "" ? 0 : Number(newValue));
                }}
              />
              {!isEqual(initialValue, value) && (
                <Button
                  onClick={onSave}
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor: primary,
                    "&:hover": { opacity: 0.6, backgroundColor: primary },
                  }}
                >
                  Save
                </Button>
              )}
              <Button
                onClick={onCancel}
                variant="outlined"
                size="small"
                sx={{ "&:hover": { opacity: 0.6 } }}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}
      </p>
    </div>
  );
};

export default SimpleSecondsContainer;
